import React from 'react';

export const ThreeDotsIcon = ({ width = 25, height = 24, color = "#585858", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none" 
        >
            <path
                className={className}
                d="M10.5 12C10.5 12.5304 10.7107 13.0391 11.0858 13.4142C11.4609 13.7893 11.9696 14 12.5 14C13.0304 14 13.5391 13.7893 13.9142 13.4142C14.2893 13.0391 14.5 12.5304 14.5 12C14.5 11.4696 14.2893 10.9609 13.9142 10.5858C13.5391 10.2107 13.0304 10 12.5 10C11.9696 10 11.4609 10.2107 11.0858 10.5858C10.7107 10.9609 10.5 11.4696 10.5 12ZM10.5 6C10.5 6.53043 10.7107 7.03914 11.0858 7.41421C11.4609 7.78929 11.9696 8 12.5 8C13.0304 8 13.5391 7.78929 13.9142 7.41421C14.2893 7.03914 14.5 6.53043 14.5 6C14.5 5.46957 14.2893 4.96086 13.9142 4.58579C13.5391 4.21071 13.0304 4 12.5 4C11.9696 4 11.4609 4.21071 11.0858 4.58579C10.7107 4.96086 10.5 5.46957 10.5 6ZM10.5 18C10.5 18.5304 10.7107 19.0391 11.0858 19.4142C11.4609 19.7893 11.9696 20 12.5 20C13.0304 20 13.5391 19.7893 13.9142 19.4142C14.2893 19.0391 14.5 18.5304 14.5 18C14.5 17.4696 14.2893 16.9609 13.9142 16.5858C13.5391 16.2107 13.0304 16 12.5 16C11.9696 16 11.4609 16.2107 11.0858 16.5858C10.7107 16.9609 10.5 17.4696 10.5 18Z"
                fill={color}
            />
        </svg>
    );
};